import axios from './api';
import {
  transformQuestionnaireJobResponse,
  transformSurveyQuestionResponseSummaryResponses,
} from './utilities/helpers';

/**
 * read survey responses summary
 * @param {Object} options
 * @param {AbortSignal} [options.signal] AbortController signal
 * @param {number} options.survey_id
 * @return {Promise}
 */
export const readSurveyResponsesSummaryGPT = async ({ signal, survey_id }) => {
  return axios({
    method: 'get',
    params: {
      survey_id,
    },
    signal,
    url: '/surveygpt/gptjob/',
  }).then(({ data }) => transformSurveyQuestionResponseSummaryResponses(data));
};

/**
 * create summary GPT feedback
 * @param {Object} options
 * @param {Object} options.data
 * @param {number} options.jobId
 * @param {AbortSignal} [options.signal] AbortController signal
 * @return {Promise}
 */
export const createSummaryGPTFeedback = async ({ data, jobId, signal }) => {
  return axios({
    data: data,
    method: 'post',
    signal,
    url: `/surveygpt/gptjob/${jobId}/feedback/`,
  }).then(({ data }) => data);
};

/**
 * create AI generated questionnaire job
 * @param {Object} options
 * @param {number} options.length
 * @param {AbortSignal} [options.signal]
 * @param {string} options.userInput
 * @return {Promise}
 */
export const createQuestionnaireJob = async ({ length, signal, userInput }) => {
  return axios({
    data: {
      prompts: { question_number: length, user_input: userInput },
      report_type: 'QUESTIONNAIRE',
    },
    method: 'post',
    signal,
    url: '/surveygpt/gptjob/',
  }).then((response) => response.data);
};

/**
 * read AI generated questionnaire job
 * @param {Object} options
 * @param {number} options.jobId
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const readQuestionnaireJob = async ({ jobId, signal }) => {
  return axios({
    method: 'get',
    signal,
    url: `/surveygpt/gptjob/${jobId}`,
  }).then(({ data }) => transformQuestionnaireJobResponse(data));
};
